import React from "react"
import styled from "styled-components"
import { Flex } from "../../layout/reusables"
import { colors } from "../../styles/colors"
import { Heading, HeadlineText } from "../../styles/typography"

export default function PhotoPreviewItem({ item, selectPhoto }) {
 
    return (
        <Container >
            <Image src={item.url} onClick={() => selectPhoto(item)} />
            <Title>{item.title}</Title>
        </Container>
    )
}

const Container = styled(Flex)`
    flex-direction: column;
    border-radius: 2px;
    /* padding: 15px; */
    transition: 0.2s ease;
    cursor: pointer;
`
const Image = styled.img`
    height: 250px;
    border-radius: 4px;
    width: 100%;
    margin-bottom: 20px;
    object-fit: cover;
`;

const Title = styled.p`
    font-size: 18px;
    text-decoration: none;
    line-height: 1.4;
    transition: 0.2s ease;
    font-weight: 400;
    margin-bottom: 5px;
    opacity: 0.9;

    @media (max-width: 550px) {
        font-size: 16px;
        line-height: 1.2;
        margin-bottom: 15px;
    }

    ${Container}:hover & {
        color: ${colors.blue};
    }
`